import axios from 'axios'
import { countryConfig } from '../country-config/country-config'

const baseURL = `${countryConfig.utilities}`;

export default axios.create({ baseURL });